/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IAai20Visitor } from '../v2/visitors/IAai20Visitor';
import { Node } from '../../core/models/Node';
import { IVisitor } from '../../core/visitors/IVisitor';
import { AaiOperationBase } from './AaiOperationBase';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} opType
 * @class
 * @extends AaiOperationBase
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiOperationTrait extends AaiOperationBase implements IAaiTrait {
    public constructor(parent? : any, opType? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof opType === 'string') || opType === null)) {
            let __args = arguments;
            super(parent, opType);
        } else if(((typeof parent === 'string') || parent === null) && opType === undefined) {
            let __args = arguments;
            let opType : any = __args[0];
            super(opType);
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && opType === undefined) {
            let __args = arguments;
            super(parent);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.models.IAaiTrait#getTraitType()
     * @return {AaiTraitType}
     */
    public getTraitType() : AaiTraitType {
        return AaiTraitType.operation;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Operation#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAai20Visitor = <IAai20Visitor><any>visitor;
        v.visitOperationTrait(this);
    }
}
AaiOperationTrait["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiOperationTrait";
AaiOperationTrait["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.asyncapi.models.IAaiTrait","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { AaiTraitType } from './AaiTraitType';


import { IAaiTrait } from './IAaiTrait';

